module.exports = __webpack_public_path__ + "img/567x600px-Aszfalt.ac239398.jpg";